module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Novo Valor"
    },
    on: {
      "click": _vm.onRegister
    }
  }), _vm._v(" "), _c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum item encontrado",
      "busy": _vm.parent.config.loading.content,
      "items": _vm.tableData,
      "fields": _vm.tableHead,
      "stacked": (this.device == 'xs')
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_text) ? _c('el-input', {
          attrs: {
            "maxlength": 150,
            "disabled": data.item._data.ativo == 0,
            "type": "text"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_numeric) ? _c('el-input-number', {
          attrs: {
            "disabled": data.item._data.ativo == 0,
            "min": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_select) ? _c('el-select', {
          attrs: {
            "clearable": true,
            "placeholder": "Selecione",
            "disabled": data.item._data.ativo == 0 || (_vm.parent.formData.id_tipo_campo != 212 && _vm.parent.formData.id_tipo_campo != 217)
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }, _vm._l((_vm.tipo_campos), function(tipo) {
          return _c('el-option', {
            key: tipo.id,
            attrs: {
              "label": tipo.descricao,
              "value": tipo.id,
              "title": tipo.obs
            }
          }, [_c('div', [_vm._v(_vm._s(tipo.descricao))]), _vm._v(" "), (tipo.obs) ? _c('div', {
            staticStyle: {
              "color": "#8492a6",
              "font-size": "13px"
            }
          }, [_vm._v(_vm._s(tipo.obs))]) : _vm._e()])
        }), 1) : (data.field && data.field.show_boolean) ? _c('el-switch', {
          attrs: {
            "active-value": 1,
            "inactive-value": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-left item-group"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  }), _vm._v("\n\t\tVALORES DESSE CAMPO\n\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df927de0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/tabela-dinamica/coluna/valores.vue
// module id = 1558
// module chunks = 45